import { render } from "./organizationInformation.vue?vue&type=template&id=3ac40630&scoped=true&ts=true"
import script from "./organizationInformation.vue?vue&type=script&lang=ts"
export * from "./organizationInformation.vue?vue&type=script&lang=ts"

import "./organizationInformation.vue?vue&type=style&index=0&id=3ac40630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac40630"]])

export default __exports__